import { Component } from '@angular/core';

@Component({
  selector: 'app-not-authorised',
  standalone: true,
  imports: [],
  templateUrl: './not-authorised.component.html',
  styleUrls: ['./not-authorised.component.css'],
})
export class NotAuthorisedComponent {

}
